// TermsOfServicePage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink, } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const TermsOfServicePage = () => {
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Legal & Company', path: '/legal' },
    { name: 'Terms of Service', path: '/legal/terms-of-service' },
  ];

  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: 'By accessing or using our platform, you agree to be bound by these Terms of Service and all terms incorporated by reference. If you do not agree to all of these terms, do not use our platform.',
    },
    {
      title: '2. User Accounts',
      content: 'You must register for an account to access certain features of the platform. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.',
    },
    {
      title: '3. Trading Rules and Guidelines',
      content: 'All transactions on the platform must adhere to our specified trading rules. This includes guidelines on material quality, quantity, pricing, and delivery. Any violation may result in account suspension.',
    },
    {
      title: '4. Intellectual Property',
      content: 'All content on this platform, including text, graphics, logos, and software, is the property of our company or its licensors and is protected by intellectual property laws. You may not use any content without express written permission.',
    },
    {
      title: '5. Limitation of Liability',
      content: 'Our platform is provided "as is" without warranties of any kind. We shall not be liable for any damages arising out of your use or inability to use the platform, including direct, indirect, incidental, punitive, and consequential damages.',
    },
    {
      title: '6. Governing Law',
      content: 'These Terms of Service shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law principles.',
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Terms of Service
        </Typography>

        <Typography variant="body1" align="center" sx={{ mb: { xs: 4, md: 6 }, maxWidth: '800px', mx: 'auto', color: 'text.secondary' }}>
          Please read these Terms of Service carefully before using our platform. These terms outline your rights and obligations when accessing and utilizing our services.
        </Typography>

        <Box sx={{ mt: 6 }}>
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                mb: 4,
                p: { xs: 2, md: 3 },
                borderRadius: 2,
                background: 'background.paper',
                border: '1px solid',
                borderColor: 'grey.100',
                boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
              }}
            >
              <Typography variant="h5" fontWeight={600} sx={{ mb: 1.5, color: 'primary.dark' }}>
                {section.title}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {section.content}
              </Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
          Last updated: July 29, 2024
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;
